import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';

import { PresetService } from './preset.service';
import { provideComponents } from './provide';
export class PresetModule {
/**
 * @param {?} component
 * @return {?}
 */
static forComponent(component: Type<any>): ModuleWithProviders {
    return PresetModule.forComponents([component]);
  }
/**
 * @param {?} components
 * @return {?}
 */
static forComponents(components: Type<any>[]): ModuleWithProviders {
    return {
      ngModule: PresetModule,
      providers: provideComponents(components),
    };
  }
/**
 * @param {?} presetService
 */
constructor(presetService: PresetService) {
    presetService.initDecoratedPresets();
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  exports: [],
  declarations: [],
  providers: [PresetService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PresetService, },
];
}

function PresetModule_tsickle_Closure_declarations() {
/** @type {?} */
PresetModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PresetModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
